<template>
  <div
    :class="{ filter: !isFiltered, 'filter--active': isFiltered }"
    @click="onClick"
  >
    <span class="filter-text">絞り込み</span>
    <span class="filter-icon" />
  </div>
</template>
<script>
export default {
  props: {
    isFiltered: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('clicked')
    }
  }
}
</script>
